export default __webpack_public_path__ + "static/media/iron.b85b8cf3.webp";